export const WORD_THRESHOLD = 250;
export const DWELL_MS = 20000;
export const SNOOZE_MS = 24 * 60 * 60 * 1000;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function countWords(markdown: string): number {
  return markdown.replace(/\[cite:[^\]]*\]/g, ' ').split(/\s+/).filter(Boolean).length;
}

export interface TriggerContext {
  messageId: string; content: string; sessionId: string | null; askedSessions: string[];
  snoozedUntil: number | null; optedOut: boolean; now: number; userTyping: boolean;
}

export function shouldAsk(c: TriggerContext): boolean {
  if (c.optedOut) return false;
  if (c.snoozedUntil !== null && c.now < c.snoozedUntil) return false;
  if (!c.sessionId || c.askedSessions.includes(c.sessionId)) return false;
  if (!UUID_RE.test(c.messageId)) return false;
  if (c.userTyping) return false;
  return countWords(c.content) > WORD_THRESHOLD;
}
